import { createIcon } from '@chakra-ui/react/icon'

const CircleTickIcon = createIcon({
  displayName: 'CircleTickIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      fill="currentColor"
      d="M8.397 1.333A6.674 6.674 0 0 0 1.73 8a6.674 6.674 0 0 0 6.667 6.667A6.674 6.674 0 0 0 15.064 8a6.674 6.674 0 0 0-6.667-6.667Zm0 12A5.34 5.34 0 0 1 3.064 8a5.34 5.34 0 0 1 5.333-5.333A5.34 5.34 0 0 1 13.73 8a5.34 5.34 0 0 1-5.333 5.334Z"
    />,
    <path fill="currentColor" d="m7.062 9.058-1.533-1.53-.941.944 2.475 2.47 4.47-4.47-.942-.943-3.53 3.53Z" />,
  ],
})

export default CircleTickIcon
